import React, {createRef, useContext, useEffect} from 'react';
import {Grid} from '@mantine/core';
import {useFormikContext} from 'formik'
import MantineInputField from "../../../../FormikUtils/MantineInputField";
import PhoneInput from "react-phone-number-input";
import MantineInputRefField from "../../../../FormikUtils/MantineInputRefField";
import MantineSelectField from "../../../../FormikUtils/MantineSelectField";
import MantineAutoCompleteField from "../../../../FormikUtils/MantineAutoCompleteField";
import useStyles from "../../../VehiculoForm/Checkout/styles";
import AffinityInfoContext from "../../../../../../context/AffinityContext";

export default function InformacionForm(props) {
    const {
        formField: {
            tamanioVivienda,
            tipoVivienda,
            codigosLocalidad,
            nombre,
            apellido,
            telefono,
            email,
            dni
        },
        localidadesData,
        isFirstQuotation
    } = props;
    const {values, setFieldValue} = useFormikContext()
    const {coberturasInfo} = useContext(AffinityInfoContext);
    const classes = useStyles();
    const ref = createRef();

    const tiposViviendas = [
        {value: '1021', label: 'Casa'},
        {value: '1022', label: 'Departamento'},
        {value: '1023', label: 'Vivienda en barrio cerrado'},
        {value: '1024', label: 'Vivienda transitoria'}
    ];

    const tamaniosVivienda = [
        {value: 'Chica', label:'Pequeña (Hasta 80 mts²)'},
        {value: 'Mediana', label: 'Mediana (Hasta 150 mts²)'},
        {value: 'Grande', label: 'Grande (150 mts² o más)'},
    ];

    useEffect(() => {
            Object.keys(values.coberturas).map(cobertura => {
                if (values.tamanioVivienda === 'Chica')
                    setFieldValue(`coberturas.[${cobertura}].sumaAsegurada`, coberturasInfo[cobertura].sumaChica)
                if (values.tamanioVivienda === 'Mediana')
                    setFieldValue(`coberturas.[${cobertura}].sumaAsegurada`, coberturasInfo[cobertura].sumaMediana)
                if (values.tamanioVivienda === 'Grande')
                    setFieldValue(`coberturas.[${cobertura}].sumaAsegurada`, coberturasInfo[cobertura].sumaGrande)
            })
    }, [values.tamanioVivienda]);

    useEffect(() => {
        if (isFirstQuotation) {
            Object.keys(values.coberturasAdicionales).map(cobertura => {
                if (values.tamanioVivienda === 'Chica')
                    setFieldValue(`coberturasAdicionales.[${cobertura}].sumaAsegurada`, coberturasInfo[cobertura].sumaChica)
                if (values.tamanioVivienda === 'Mediana')
                    setFieldValue(`coberturasAdicionales.[${cobertura}].sumaAsegurada`, coberturasInfo[cobertura].sumaMediana)
                if (values.tamanioVivienda === 'Grande')
                    setFieldValue(`coberturasAdicionales.[${cobertura}].sumaAsegurada`, coberturasInfo[cobertura].sumaGrande)
            })
        }
    }, []);

    return (
        <React.Fragment>
            <Grid gutter="md" justify="center" align="center">
                <Grid.Col xs={12} sm={6}>
                    <MantineInputField
                        name={nombre.name}
                        label={nombre.label}
                        withAsterisk
                    />
                </Grid.Col>
                <Grid.Col xs={12} sm={6}>
                    <MantineInputField
                        name={apellido.name}
                        label={apellido.label}
                        withAsterisk
                    />
                </Grid.Col>
                <Grid.Col xs={12} sm={6}>
                    <div className={classes.field}>
                        <PhoneInput
                            defaultCountry="AR"
                            ref={ref}
                            inputComponent={MantineInputRefField}
                            name={telefono.name}
                            label={telefono.label}
                            value={values.telefono}
                            onChange={(e) => {
                                /** @namespace e.length **/
                                if (e && e.length > 12) {
                                    setFieldValue(telefono.name, e)
                                }
                            }}
                            withAsterisk
                        />
                    </div>
                </Grid.Col>
                <Grid.Col xs={12} sm={6}>
                    <MantineInputField
                        name={dni.name}
                        label={dni.label}
                        withAsterisk
                    />
                </Grid.Col>
                <Grid.Col xs={12} sm={6}>
                    <MantineInputField
                        name={email.name}
                        label={email.label}
                        withAsterisk
                    />
                </Grid.Col>
                <Grid.Col xs={12} sm={6}>
                    <MantineSelectField
                        name={tipoVivienda.name}
                        label={tipoVivienda.label}
                        data={tiposViviendas}
                    />
                </Grid.Col>
                <Grid.Col xs={12} sm={6}>
                    <MantineAutoCompleteField
                        name={codigosLocalidad.name}
                        label={codigosLocalidad.label}
                        data={localidadesData}
                        searchable
                        withAsterisk
                    />
                </Grid.Col>
                <Grid.Col xs={12} sm={6}>
                    <MantineSelectField
                        name={tamanioVivienda.name}
                        label={tamanioVivienda.label}
                        data={tamaniosVivienda}
                    />
                </Grid.Col>
            </Grid>
        </React.Fragment>
    );
}
